import { render, staticRenderFns } from "./checkout-dot-com-payment-form.vue?vue&type=template&id=4f152b5e&scoped=true"
import script from "./checkout-dot-com-payment-form.vue?vue&type=script&lang=js"
export * from "./checkout-dot-com-payment-form.vue?vue&type=script&lang=js"
import style0 from "./checkout-dot-com-payment-form.vue?vue&type=style&index=0&id=4f152b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f152b5e",
  null
  
)

export default component.exports